import BillingCategoryModel from "./BillingCategoryModel";
import DepartmentModel from "./DepartmentModel";

export default class AddonModel {
  id: string;
  // organizationId: string;
  title: string = "";
  department?: DepartmentModel;
  description?: string = "";
  billingCategory?: BillingCategoryModel;
  order?: number;
  price: number = null;

  constructor(data: AddonModel | {}) {
    Object.assign(this, data);
  }
}
